module.exports = __webpack_public_path__ + "assets/img/thumb-DB-Results-Service-Page.49978eda.jpg";